@use 'sass:map';
@use 'ui/styles/core-tokens' as core;

.container {
  display: flex;
  flex-direction: column;
  text-align: left;
  width: 100%;

  &Label {
    padding-bottom: 4px;
  }

  &Error {
    padding-top: 4px;
  }

  &Disabled {
    opacity: 0.4;
  }

  &Input {
    border: 1px solid map.get(core.$fonts, label);
    border-radius: 2px;
    box-sizing: border-box;
    font-size: map.get(core.$sizes, m);
    height: 40px;
    padding: 11px;

    &::placeholder {
      color: map.get(core.$fonts, fontPrimaryDisabled);
    }

    &:hover {
      border-color: map.get(core.$colors, accent);
    }

    &:focus {
      border-color: map.get(core.$fonts, label);
      box-shadow: 0 0 1px 1px map.get(core.$colors, accent);
      outline: none;
    }

    &Error {
      border-color: map.get(core.$fonts, error);
    }

    &Success {
      border-color: map.get(core.$colors, success);
    }

    &:disabled {
      background-color: map.get(core.$buttons, buttonSecondaryDisabled);
      opacity: 0.4;
      pointer-events: none !important;
    }
  }
}
